import { Routes, Route, Link, useParams, useLocation } from "react-router-dom";
import './AnimatedRoutes.css';
import Blc_facilities from "../../Blc_facilities/Blc_facilities";
import Blc_Gallery from "../../Blcs_Gallery/Blc_Gallery";
import Blc_Reservation from "../../Blc_Reservation/Blc_Reservation";
import Blc_Contact from "../../Blc_Contact/Blc_Contact";
import Blc_Faq from "../../Blc_FAQ/Blc_Faq";
import Blc_Locations from "../../Blc_Locations/Blc_Location";
import BlcSingleLocation from "../../Blc_Locations/Each_location/BlcSingleLocations";
import { useBlcLocations } from "../../Blc_Business/FristSixBLC/blcLocations";
import Spinner from "react-bootstrap/Spinner";
import Blc_Blog from "../../Blc_News/Blc_Blog";
import { useBlcHighlights } from "../../Blc_Business/BlcHomeLandingPage/Blc_Highlights";
import HomeLanding from "../../Blc_Home/HomeLanding";
import Blc_Blog_Main_new_copy from "../../Blc_News/Blc_Blog_Main_new_copy";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Blc_Blog_copy from "../../Blc_News/Blc_Blog_copy";

const AnimatedRoutes = ({ props }) => {
    const myVal = useBlcLocations();
    const newsFeed = useBlcHighlights();


    const blcIndex = (index) => {

        myVal[1](index);
    };

    const newsNumber = (valNum) => {

        newsFeed[1](valNum);
    }

    function waitFordata() {
        return (
            <>
                <div className="mySpin">
                    <Spinner animation="border" />
                </div>
            </>
        );
    }

    const location = useLocation();


    return (
        <TransitionGroup>
            <CSSTransition
                key={location.key}
                classNames="page"
                timeout={700}>
                <Routes location={location}>
                    <Route
                        path="/"
                        element={
                            <HomeLanding
                                valHero={props.blcData.blc_hero_carousal}
                                valAbout={props.blcData.blc_about_us}
                                valFacilities={props.blcData.blc_facilites_services}
                                valHighlights={props.blcData.blc_highlights}
                                valDifLocations={props.blcData.blc_different_locations}
                                valReservation={props.blcData.spotlight}
                                valPartner={props.blcData.blc_partner}
                                newsNum={newsNumber}
                            />
                        }
                    />
                    <Route path="/home" element={
                        <HomeLanding
                            valHero={props.blcData.blc_hero_carousal}
                            valAbout={props.blcData.blc_about_us}
                            valFacilities={props.blcData.blc_facilites_services}
                            valHighlights={props.blcData.blc_highlights}
                            valDifLocations={props.blcData.blc_different_locations}
                            valReservation={props.blcData.spotlight}
                            valPartner={props.blcData.blc_partner}
                            newsNum={newsNumber}
                        />
                    } />
                    <Route
                        path="/locations"
                        element={
                            <Blc_Locations
                                navDataPh={props.blcData.blc_locations_dropdwon}
                                valIndex={blcIndex}
                            />
                        }
                    />
                    <Route path="/facilities" element={<Blc_facilities valFacility={props.facilityData} />} />
                    <Route path="/gallery" element={<Blc_Gallery valGallery={props.blcGalleryData} />} />
                    <Route path="/reservation" element={<Blc_Reservation valReservation={props.blcReservationData} />} />
                    <Route path="/faq" element={<Blc_Faq valFaq={props.faqsData} />} />
                    <Route path="/contact" element={<Blc_Contact valContactData={props.contactPageData} />} />

                    <Route path="/blchighlights" element={<Blc_Blog_Main_new_copy valNewsIndex={newsFeed[0]} valHighlights={props.blcData.blc_highlights} />} />
                    <Route path="/allnews" element={<Blc_Blog_copy valHighlights={props.blcData.blc_highlights} newsNum={newsNumber} />} />
                    {/* <Route path="/allnews" element={<Blc_Blog valHighlights={props.blcData.blc_highlights} newsNum={newsNumber} />} /> */}

                    <Route
                        path="/locations/:locName"
                        element={props.locationData !== undefined ? <BlcSingleLocation valIndex={myVal[0]} valData={props.locationData} /> : waitFordata()}
                    />
                </Routes>
            </CSSTransition>
        </TransitionGroup>
        // <Routes>

        //     <Route

        //         path="/"
        //         element={
        //             <HomeLanding
        //                 valHero={props.blcData.blc_hero_carousal}
        //                 valAbout={props.blcData.blc_about_us}
        //                 valFacilities={props.blcData.blc_facilites_services}
        //                 valHighlights={props.blcData.blc_highlights}
        //                 valDifLocations={props.blcData.blc_different_locations}
        //                 valReservation={props.blcData.spotlight}
        //                 valPartner={props.blcData.blc_partner}
        //                 newsNum={newsNumber}
        //             />
        //         }
        //     />
        //     <Route path="/home" element={
        //         <HomeLanding
        //             valHero={props.blcData.blc_hero_carousal}
        //             valAbout={props.blcData.blc_about_us}
        //             valFacilities={props.blcData.blc_facilites_services}
        //             valHighlights={props.blcData.blc_highlights}
        //             valDifLocations={props.blcData.blc_different_locations}
        //             valReservation={props.blcData.spotlight}
        //             valPartner={props.blcData.blc_partner}
        //             newsNum={newsNumber}
        //         />
        //     } />
        //     <Route
        //         path="/locations"
        //         element={
        //             <Blc_Locations
        //                 navDataPh={props.blcData.blc_locations_dropdwon}
        //                 valIndex={blcIndex}
        //             />
        //         }
        //     />
        //     <Route path="/facilities" element={<Blc_facilities valFacility={props.facilityData} />} />
        //     <Route path="/gallery" element={<Blc_Gallery valGallery={props.blcGalleryData} />} />
        //     <Route path="/reservation" element={<Blc_Reservation valReservation={props.blcReservationData} />} />
        //     <Route path="/faq" element={<Blc_Faq valFaq={props.faqsData} />} />
        //     <Route path="/contact" element={<Blc_Contact valContactData={props.contactPageData} />} />

        //     <Route path="/blchighlights" element={<Blc_Blog_Main_new_copy valNewsIndex={newsFeed[0]} valHighlights={props.blcData.blc_highlights} />} />
        //     <Route path="/allnews" element={<Blc_Blog valHighlights={props.blcData.blc_highlights} newsNum={newsNumber} />} />

        //     <Route
        //         path="/locations/:locName"
        //         element={props.locationData !== undefined ? <BlcSingleLocation valIndex={myVal[0]} valData={props.locationData} /> : waitFordata()}
        //     />

        // </Routes>
    );
};

export default AnimatedRoutes;